import { Box } from "@mui/material";
import { AskAidenCard } from "components/modules/ask-aiden";

const askAiden = () => {
  return <Box>{AskAidenCard()}</Box>;
};

export default askAiden;
